import EnumSelect from "@/components/EnumSelect";
import Field from "@/components/Field";
import CheckboxField from "@/components/CheckboxField";
import { useIsAdmin } from "@/modules/account/hooks/useIsAdmin";
import {
  PLANNED_DURATION_FUTURE_SCOPES,
  PLANNED_DURATION_PAST_SCOPES,
} from "@/schemas/project";
import { useWatch } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { ProjectPlannedDurationNetworkFields } from "./ProjectPlannedDurationNetworkFields";

export const ProjectPlannedDurationVisibilityFields = ({
  disabled = false,
  networks = [],
  availableNetworks = [],
}: {
  disabled?: boolean;
  networks?: { id: string; name: string }[];
  availableNetworks?: { id: string; name: string }[];
}) => {
  const { t } = useTranslation();
  const isAdmin = useIsAdmin();
  const enabled = useWatch({
    name: "contractor_visits_planned_duration_visible",
  });
  return (
    <>
      <div className="grid grid-cols-1 gap-4 lg:grid-cols-3">
        <CheckboxField
          name="contractor_visits_planned_duration_visible"
          label={t(
            "projects.fields.contractor_visits_planned_duration_visible",
          )}
          disabled={disabled || !isAdmin}
          className="pt-0 lg:pt-6"
        />
        {enabled && (
          <>
            <Field
              name="contractor_visits_planned_duration_past_scope"
              label={t(
                "projects.fields.contractor_visits_planned_duration_past_scope",
              )}
              render={({ field }) => (
                <EnumSelect
                  {...field}
                  value={field.value ?? "today"}
                  options={PLANNED_DURATION_PAST_SCOPES}
                  translationKey="projects.plannedDurationVisibility.past"
                  disabled={disabled || !isAdmin}
                />
              )}
            />
            <Field
              name="contractor_visits_planned_duration_future_scope"
              label={t(
                "projects.fields.contractor_visits_planned_duration_future_scope",
              )}
              render={({ field }) => (
                <EnumSelect
                  {...field}
                  value={field.value ?? "today_next_visit"}
                  options={PLANNED_DURATION_FUTURE_SCOPES}
                  translationKey="projects.plannedDurationVisibility.future"
                  disabled={disabled || !isAdmin}
                />
              )}
            />
          </>
        )}
      </div>
      <ProjectPlannedDurationNetworkFields
        disabled={disabled}
        networks={networks}
        availableNetworks={availableNetworks}
      />
    </>
  );
};
